
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Carousel, CarouselItem } from 'element-ui'
import Projects from '@/pages/index/components/MobileProjects.vue'
import { ProductManager } from '@/commons/productManager'
import { ProductService } from '@/commons/productService'
Vue.use(Carousel)
Vue.use(CarouselItem)
@Component({
  components: {
    Projects
  }
})
export default class HorizontalMenu extends Vue {
  private pid = 0

  private productManager = new ProductManager(new ProductService())

  async mounted () {
    await this.productManager.getProductTree()
  }
  // private manager = new BannerManageImpl(new BannerService())
  // async mounted () {
  //   const res = this.manager.getProjectSystemInfor()
  //   console.log(this.manager.ProjectSystemList)
  // }
}
